import { takeLatest } from 'redux-saga/effects';

import { SET_SHOW_WHERE_ARE_YOU_MODAL } from './actions';
import { onSetShowWhereAreYouModal } from './effects';

export function* setShowLocalizationSettingsSaga() {
  yield takeLatest(SET_SHOW_WHERE_ARE_YOU_MODAL, onSetShowWhereAreYouModal);
}
